// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-3019aec6]{-webkit-transition:.2s ease-in-out;transition:.2s ease-in-out}", ""]);
// Exports
module.exports = exports;
